<template>
  <AppLayout v-if="collaborator" :title="title">
    <template v-slot:buttons>
      <Button type="danger" prepend-icon="trash" @click="deleteCollaborator" />
    </template>

    <Row lg="row">
      <Column lg="2/3">
        <Card title="Details" :noPadding="true">
          <template v-slot:buttons>
            <Button prepend-icon="pencil" @click="editCollaborator" />
          </template>

          <dl class="dl-horizontal">
            <dt>Name</dt>
            <dd>{{ collaborator.name }}</dd>
            <dt>Slug</dt>
            <dd>{{ collaborator.slug }}</dd>
            <dt>Logo</dt>
            <dd>
              <img v-if="collaborator.logo" :src="collaborator.logo.full_url" alt="Logo" class="img-responsive" />
              <span v-else class="text-supplement">-</span>
            </dd>
          </dl>
        </Card>

        <Card title="API Information" :noPadding="true">
          <template v-slot:buttons>
            <Button
              prepend-icon="clipboard"
              v-clipboard="`${collaborator.api_key}:${collaborator.api_secret}`"
              v-clipboard:success="onCopy"
            />
          </template>

          <dl class="dl-horizontal">
            <dt>API Key</dt>
            <dd>{{ collaborator.api_key }}</dd>
            <dt>API Secret</dt>
            <dd>{{ collaborator.api_secret }}</dd>
          </dl>
        </Card>
      </Column>
    </Row>
  </AppLayout>
</template>

<script>
import EditCollaboratorModal from "@/modals/Collaborators/EditCollaboratorModal.vue"

export default {
  metaInfo() {
    return { title: this.title }
  },
  data: () => ({
    loading: true,
    title: null,
    collaborator: null
  }),
  async created() {
    await this.fetchCollaborator()
  },
  methods: {
    async fetchCollaborator() {
      this.loading = true
      const response = await this.$api.get(`collaborators/${this.$route.params.id}`)
      this.collaborator = response.data.data
      this.title = this.collaborator.name
      this.loading = false
    },
    async editCollaborator() {
      const response = await this.$modal.show(EditCollaboratorModal, {
        endpoint: `collaborators/${this.$route.params.id}`
      })

      if (response) {
        this.collaborator = response.data
        this.title = this.collaborator.name
      }
    },
    onCopy() {
      this.$notification.success("Copied!")
    },
    async deleteCollaborator() {
      if (
        await this.$modal.confirm({
          type: "danger",
          message: `Are you sure you want to delete **${this.collaborator.name}**?`,
          buttonText: "Delete"
        })
      ) {
        if (await this.$api.delete(`collaborators/${this.$route.params.id}`)) {
          this.$notification.success(`Collaborator **${this.collaborator.name}** successfully deleted.`)
          this.$router.push({ name: "collaborators" })
        }
      }
    }
  }
}
</script>
